import { Typography } from "@mui/material";
import { DetailItem } from "../../../components/ModalDetailsGeneric/ModalDetailsGeneric";
import { applyVolumeMask, getColorIfGreaterThanZero } from "../../../utils";
import {
  QUOTE_BALANCE_DETAIL_FIELDS,
  QuoteBalanceRawRow,
} from "./quoteBalanceDetailFields";

export function buildQuoteBalanceDetailItems(
  row: QuoteBalanceRawRow
): DetailItem[] {
  return QUOTE_BALANCE_DETAIL_FIELDS.map(({ label, key }) => {
    const rawValue = row[key] ?? 0;
    const numericValue = Number(rawValue);
    const formattedValue = applyVolumeMask(String(numericValue)) || "0";
    const color = getColorIfGreaterThanZero(numericValue);

    return {
      label,
      value: <Typography color={color}>{formattedValue}</Typography>,
    };
  });
}
